<template>
    <div>
    <app-toolbarcustom :app_title="form.title" app_menu="sop"></app-toolbarcustom>
    <v-progress-linear
    indeterminate
    color="fourth"
    rounded
    v-if="loading.page"
    ></v-progress-linear>
    <v-card flat>
        <v-list two-line>
            <v-subheader></v-subheader>
            <template v-for="(item, index) in posts">
                <v-list-item
                  :key="item.letter_id"
                  @click="$functions.OpenUrl(item.letter_path_url)"
                >
                  <v-list-item-avatar>
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{item.letter_id}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.letter_subject}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                v-if="index + 1 < posts.length"
                :key="index"
              ></v-divider>
           </template>
        </v-list>
    </v-card>
    </div>
</template>
<script>
    export default {
        data: () => ({
            loading: {
                page: false
            },
            form: {
                id: '',
                title: '',
            },
            posts: []
        }),
        created() {
            this.FirstLoad()
        },
        // computed: {
        //     filteredposts() {
        //         return this.posts.filter(post => {
        //                 return post.letter_subject === this.$functions.UsersCompany()
        //         })
        //     },
        // },
        methods: {
            FirstLoad () {
                this.loading.page = true
                this.form.id = this.$functions.DecodeUrl(this.$route.params.id)
                this.form.title = this.$functions.DecodeIndexUrl(this.$route.params.id, 2)
                let formdata = {
                  letter_category: this.form.id,
                  letter_sop: 'Y',
                  letter_actived: 'Y',
                  order_by: 'letter_cdate',
                  order_type: 'ASC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListLetter'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts = feedback
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            }
        }
    }
</script>